import { AppRoute } from '@percent/workplace-giving/routing/AppRoute.enum'

const NAME_PARAM = 'name'
const COUNTRY_PARAM = 'country'

type RequestNonprofitPrefill = {
  name: string
  countryCode: string
}

// Links to the Request to add a nonprofit page, prefilled with what the user already entered on the page they came from.
export const getRequestNonprofitPath = ({ name, countryCode }: RequestNonprofitPrefill) => {
  const searchParams = new URLSearchParams({
    ...(name ? { [NAME_PARAM]: name } : {}),
    ...(countryCode ? { [COUNTRY_PARAM]: countryCode } : {})
  }).toString()

  return searchParams ? `${AppRoute.REQUEST_NONPROFIT}?${searchParams}` : AppRoute.REQUEST_NONPROFIT
}

export const getRequestNonprofitPrefill = (searchParams: URLSearchParams): RequestNonprofitPrefill => ({
  name: searchParams.get(NAME_PARAM) ?? '',
  countryCode: searchParams.get(COUNTRY_PARAM) ?? ''
})
